interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  color?: "cyan" | "blue" | "green" | "red" | "purple" | "orange" | "yellow";
}

export function Radio(props: Props) {
  const { className, color = "cyan", ...rest } = props;

  const colorClasses = {
    cyan: "accent-cyan",
    blue: "accent-blue-500",
    green: "accent-green-600",
    red: "accent-red-500",
    purple: "accent-purple-500",
    orange: "accent-orange-500",
    yellow: "accent-yellow-500",
  };

  return (
    <input
      type="radio"
      {...rest}
      className={`h-4 w-4 ${colorClasses[color]} rounded-full cursor-pointer ${className}`}
    />
  );
}
